/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "./api-client";
export const useGetVansInsuranceLimits = (data: any) =>
  useQuery<any>({
    queryKey: [
      "vansInsuranceLimits",
      data?.operationDate,
      data?.cashCenterId,
      data?.pageRowCount,
      data?.pageNumber,
      data?.searchCriteria,
      data?.region,
      data?.routeStatus,
      data?.limitStatus,
    ],
    queryFn: () => client(`daily/operations/vans/insurance/limits`, { data }),
  });

export const useGetRoutePackages = (data: any) =>
  useQuery<any>({
    queryKey: [
      "routePackages",
      data?.operationDate,
      data?.cashCenterId,
      data?.routeNo,
      data?.shift,
    ],
    queryFn: () => client(`daily/operations/route/packages`, { data }),
  });

export const useValidateFieldTeam = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/check/team/member/assignment`, { data }),
  });
